import { CityType } from "@smile2impress/location-content";

export const filterCitiesByFlagship = (
    cities: CityType[],
    hasFlagship: boolean
): CityType[] => {
    return cities.filter(
        (city) =>
            city.clinics.some((clinic) => clinic.isFlagship) === hasFlagship
    );
};
